module.exports = __webpack_public_path__ + "img/zhengshu_up.5abf23da.png";